import { z } from "zod";

/**
 * A rating is REQUIRED to add a constraint to a person — there is no unrated
 * row, and no zero. "No familiarity" is recorded by the person simply not
 * having that constraint, which is why removal (not a low score) is the way to
 * take one back.
 */
const constraintRating = z
  .number()
  .int()
  .min(1, "Pick a rating")
  .max(5, "Pick a rating between 1 and 5");

/**
 * The target is a (grouping, NOS value) pair rather than a local id, because the
 * pick list lives in NOS and Enable has no row of its own to point at. The pair
 * is belt-and-braces: all four NOS primary keys are `uniqueidentifier`, so the
 * value id alone is already unique across the four lists, but carrying the
 * grouping means a mismatched pair is refused rather than silently resolved.
 */
export const addPersonConstraintSchema = z.object({
  typeKey: z.string().trim().min(1, "Pick a constraint"),
  valueId: z.string().trim().min(1, "Pick a constraint"),
  level: constraintRating,
  notes: z.string().trim().max(2000).nullable().optional(),
});

/** The constraint itself is not re-targetable — remove and re-add instead. */
export const updatePersonConstraintSchema = z.object({
  level: constraintRating.optional(),
  notes: z.string().trim().max(2000).nullable().optional(),
});

export type AddPersonConstraintInput = z.infer<typeof addPersonConstraintSchema>;
export type UpdatePersonConstraintInput = z.infer<typeof updatePersonConstraintSchema>;
